import React from 'react'

function ContactBlock({Icon, heading, para}) {
    return (
    <div className=" h-48 w-60 rounded-sm bg-[#88888811] mt-12 flex flex-col justify-center items-center text-center mr-10 cursor-pointer transition duration-200 hover:bg-blue-700">
            <Icon className="contact__icon"/>
            <p className="mt-4">{heading}</p>
            <p className="w-60 mt-4">{para}</p>
        </div>
    )
}

export default ContactBlock
